import { render, staticRenderFns } from "./SystemComponentsHierarchyAdd.vue?vue&type=template&id=7c6a64a2&"
import script from "./SystemComponentsHierarchyAdd.vue?vue&type=script&lang=js&"
export * from "./SystemComponentsHierarchyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports